// extracted by mini-css-extract-plugin
module.exports = {"welcome":"Welcome_welcome__2hdqU","logo":"Welcome_logo__mBb1K"};